export default "__VITE_ASSET__BgmVYkXX__"